import {AfterContentChecked, Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import {SnackBarService} from '@core/services/snack-bar.service';
import {OptionItem} from '@shared/models/option-item';
import {ActionsCellComponent} from '@shared/components/cell-components/actions-cell/actions-cell.component';
import {getFileStoreSelectedGridItems} from '@features/file-manager/store/selectors/file-manager.selectors';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {Subject} from 'rxjs';
import {
  GridSelectedItem,
  IconViewModel,
  multipleSelectorContextMenu,
  PermissionList
} from '@features/file-manager/models/file-manager.model';
import {FileManagerState} from '@features/file-manager/store/reducers/file-manager.reducer';
import {FileGridItemSelectionChangedAction} from '@features/file-manager/store/actions/file-manager.actions';
import {DataItem, VirtualGridSelectionService} from '@core/services/virtual-grid-selection.service';

@Component({
    standalone: false,
    selector: 'particle-drive-row-actions-cell-viewer',
  templateUrl: './drive-row-actions-cell-viewer.component.html',
  styleUrls: ['./drive-row-actions-cell-viewer.component.scss']
})
export class DriveRowActionsCellViewerComponent extends ActionsCellComponent implements OnInit, AfterContentChecked, OnDestroy {
  selectedList: DataItem[] = [];
  isLocked = false;
  ngUnsubscribe$ = new Subject<void>();
  constructor(protected snackBarService: SnackBarService,
              private platformSidebarStore: Store<PlatformSidebarState>,
              protected store: Store<FileManagerState>,
              private virtualGridSelectionService: VirtualGridSelectionService) {
   super(snackBarService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.virtualGridSelectionService.virtualGridSelection$().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(virtualGridSelection => {
      if (virtualGridSelection.sourceType === this.sourceType) {
        this.selectedList = virtualGridSelection.itemSelections;

        if (virtualGridSelection.itemSelections.length > 0) {
          this.isLocked = !virtualGridSelection.itemSelections.some(o => this.item.id === o.id);
          this.actions = this.getMultipleSelectActionMenu();
        } else {
          this.isLocked = false;
          this.setActions();
        }
      } else if (this.virtualGridSelectionService.virtualGridSelection(this.sourceType).itemSelections.length === 0) {
        this.setActions();
      }
    });
  }

  ngAfterContentChecked(): void {
    if (this.selectedList.length > 0) {
      this.isLocked = !this.selectedList.some( o => this.item.id ===  o.id);
      this.actions = this.getMultipleSelectActionMenu();
    } else {
      this.isLocked = false;
      this.setActions();
    }
    if (this.actions.length === 0) {
      this.item.isCheckBoxLocked = true;
    }
  }

  getMultipleSelectActionMenu() {
    let lowestPermission = 0;
    PermissionList.some(permission => {
      const hasPermissionToItems = this.selectedList.every((o: DataItem) =>
        o.cells['UserPermission'].value >= permission);
      if (hasPermissionToItems) {
        lowestPermission = permission;
        return true;
      }
    });
    const availableSelectorContextMenu = multipleSelectorContextMenu.filter(menu => {
      if (menu.tags.length > 0) {
        let hasTagInAllItems = true;
        menu.tags.forEach(tag => {
          hasTagInAllItems = this.selectedList.every((o: DataItem) =>
            o.cells['Tag'].value.split(',').find( t => t === tag) !== undefined);
          if (!hasTagInAllItems) {
            return;
          }
        });
        return hasTagInAllItems;
      }
      return true;
    });
    return availableSelectorContextMenu.filter(menu => menu.minimumPermission <= lowestPermission);
  }


  onSelectActionType(action) {
    this.setDisabledAttribute(action);
    if (action.disabled) {
      this.snackBarService.showWarning('Permission Denied');
      return;
    }
    const payload = {
      item: this.item,
      fieldDefinition: this.fieldDefinition,
      action: action
    };
    this.valueChanged.emit(payload);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}

